import { Col, Row, Result } from "antd"

/**
 * Note: This component depends on the global styles defined in the AppDisabledMessage.styles.sass file
 */
export const AppDisabledMessage = () => {
  return (
    <Row align="middle" className="ficosec-app-disabled">
      <Col span={24}>
        <Result
          status={404}
          subTitle="Estaremos de vuelta lo más pronto posible"
          title="Estamos trabajando para mejorar la plataforma" />
      </Col>
    </Row>
  )
}
